var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mrgt- lastKnownLocation"},[_vm._v(" "+_vm._s(_vm.$t('users.statuses.last-known-localisation', { localisationTimeFromNow: _vm.localisationTimeFromNow }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }